import * as ko from 'knockout'
import { Params, RaceStarterViewModel } from './RaceStarterViewModel'
import template from './race.starter.tpl.html'

if (!ko.components.isRegistered('race-starter')) {
  ko.components.register('race-starter', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new RaceStarterViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
